import { useCallback } from 'react';
import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { useMeContext } from '~/modules/me';
import { resourceMatchesFragment } from '~/modules/resourcing/common/fragments';
import { ResourceMatchesStatus } from '~/types';

export const BULK_MARK_RESOURCE_REQUESTS_AS_SUBMITTED = gql`
  mutation bulkMarkResourceRequestsAsSubmitted2(
    $input: BulkMarkResourceRequestsAsSubmittedInput!
  ) {
    bulkMarkResourceRequestsAsSubmitted2(input: $input) {
      resourceRequests {
        id
        requestStatus
      }
    }
  }
`;

const updateResourceMatchesCache = ({ isPsaPraaResourceMatchingEnabled }) => (
  proxy,
  { data }
) => {
  if (data) {
    const { bulkMarkResourceRequestsAsSubmitted2 } = data;

    bulkMarkResourceRequestsAsSubmitted2?.resourceRequests?.forEach(
      resourceRequest =>
        proxy.writeFragment({
          id: `ResourceRequest:{"id":"${resourceRequest.id}"}`,
          fragment: resourceMatchesFragment,
          variables: {
            resourceMatchesPage: 1,
            resourceMatchesPageSize: 1,
            isPsaPraaResourceMatchingEnabled
          },
          data: {
            resourceMatches: null,
            resourceMatchesStatus: ResourceMatchesStatus.InProgress
          }
        })
    );
  }
};

export const useBulkMarkResourceRequestsAsSubmitted = () => {
  const { featureFlags } = useMeContext();
  const [bulkMarkResourceRequestsAsSubmitted] = useMutation(
    BULK_MARK_RESOURCE_REQUESTS_AS_SUBMITTED
  );

  const bulkMarkResourceRequestsAsSubmittedCallback = useCallback(
    resourceRequestIds =>
      bulkMarkResourceRequestsAsSubmitted({
        variables: {
          input: {
            resourceRequestIds
          }
        },
        update: updateResourceMatchesCache({
          isPsaPraaResourceMatchingEnabled:
            featureFlags.isPsaPraaResourceMatchingEnabled
        })
      }),
    [
      bulkMarkResourceRequestsAsSubmitted,
      updateResourceMatchesCache,
      featureFlags
    ]
  );

  return {
    bulkMarkResourceRequestsAsSubmitted: bulkMarkResourceRequestsAsSubmittedCallback
  };
};

export default useBulkMarkResourceRequestsAsSubmitted;
